import { render, staticRenderFns } from "./CompanyBankAccountsCreateOrUpdate.vue?vue&type=template&id=0f565f85&"
import script from "./CompanyBankAccountsCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./CompanyBankAccountsCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports